import { render } from "./MakeSaleInvoicePaymentModal.vue?vue&type=template&id=7245a7f8"
import script from "./MakeSaleInvoicePaymentModal.vue?vue&type=script&lang=js"
export * from "./MakeSaleInvoicePaymentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__